<ng-container *ngIf="doctor$ | async as doctor">
    <fa-icon [icon]="'user'" class="image bigger"></fa-icon>
    <div class="main content">
        <strong class="bigger">{{ doctor.DisplayName }}</strong>
        <span>{{ doctor?.Schwerpunkt }}</span>
        <div *ngIf="doctorCatalogs$ | async as doctorcatalogs">
            <span *ngIf="doctorcatalogs?.length">
                <li *ngFor="let doctorcatalog of doctorcatalogs">
                    {{ doctorcatalog?.Name }}
                </li>
            </span>
        </div>
        <div *ngIf="qualifications$ | async as qualifications">
            <span *ngIf="qualifications?.length">
                <li *ngFor="let qualification of qualifications">
                    {{ qualification?.Name }}
                </li>
            </span>
        </div>
        <a class="link" *ngIf="doctor.Email as value" [href]="'mailto:' + value" (click)="$event.stopPropagation()">{{ value }}</a>
        <ng-content></ng-content>
    </div>
    <div class="side content">
        <span class="link" *ngIf="doctor.Lanr as value">{{ value }}</span>
        <span class="link" *ngIf="doctor.IsActive as value">
            {{ value ? 'aktiv' : 'inaktiv' }}
        </span>
    </div>
</ng-container>
